<mat-form-field class="w-full">
    <mat-label><apcam-translation [model]="inputConfig.label" /></mat-label>
    <textarea
        matInput
        [formControlName]="formcontrolName"
        [placeholder]="
            showPlaceholder()
                ? inputConfig.placeholder.translations[currentLang]
                : ''
        "
        [rows]="inputConfig.rows"
        [required]="inputConfig.required"></textarea>
    @if (input.hasError('required')) {
        <mat-error>
            {{ 'shared.validation.required' | translate }}
        </mat-error>
    } @else if (input.hasError('minlength')) {
        <mat-error>
            {{
                'shared.validation.minChars'
                    | translate
                        : { min: input.getError('minlength').requiredLength }
            }}
        </mat-error>
    } @else if (input.hasError('maxlength')) {
        <mat-error>
            {{
                'shared.validation.maxChars'
                    | translate
                        : { max: input.getError('maxlength').requiredLength }
            }}
        </mat-error>
    }
</mat-form-field>
